import * as XLSX from 'xlsx'
import {
  DISPATCH_LINE_DETAIL_COLUMNS_DEFAULT,
  getCellDisplayValue,
  resolveLineDetailExportColumns
} from '@/utils/dispatchLineDetailsColumns'

function cellValue(row, col) {
  const v = getCellDisplayValue(row, col)
  if (v === '') return ''
  return v
}

/**
 * @param {object[]} rows
 * @param {object[]} [columns] 列配置（按可见列 + exportAlways 列解析后导出）
 * @param {string} [filenamePrefix]
 */
export function exportDispatchLineDetailsToExcel(
  rows,
  columns = DISPATCH_LINE_DETAIL_COLUMNS_DEFAULT,
  filenamePrefix = '派工明细汇总'
) {
  const list = Array.isArray(rows) ? rows : []
  const exportCols = resolveLineDetailExportColumns(columns)
  const header = exportCols.map((c) => c.labelFull || c.label)
  const body = list.map((row) => exportCols.map((c) => cellValue(row, c)))
  const ws = XLSX.utils.aoa_to_sheet([header, ...body])
  ws['!cols'] = exportCols.map((c) => ({
    wch: Math.min(48, Math.max(8, Math.ceil(((c.labelFull || c.label || '').length + (c.width || 80)) / 8)))
  }))
  const wb = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(wb, ws, '派工明细')
  const ts = new Date()
  const pad = (n) => String(n).padStart(2, '0')
  const fn = `${filenamePrefix}_${ts.getFullYear()}${pad(ts.getMonth() + 1)}${pad(ts.getDate())}_${pad(ts.getHours())}${pad(ts.getMinutes())}.xlsx`
  XLSX.writeFile(wb, fn)
  return fn
}
